

















import Vue from 'vue'
import SignInUpCommon from '@/components/user/SignInUpCommon.vue'
import Block from '@/components/Block.vue'

export default Vue.extend({
  name: 'ThankYouForSubscribing',
  components: {
    SignInUpCommon,
    Block,
  },
  data: () => ({}),
})
